import { Grid, Tabs } from '@mui/material';
import React, { useState, useRef } from 'react';
import { ICandidate } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import UpdateCandidateDetailsCard from './UpdateCandidateDetailsCard';
import ProfileTab from './utilities/ProfileTab';

interface CandidateProfileDetailsProps {
  close: () => void;
  candidate: ICandidate;
  updateCandidate?: (data: ICandidate) => void;
}

const CandidateProfileDetailsEdit: React.FC<CandidateProfileDetailsProps> = ({
  close,
  candidate,
  updateCandidate,
}) => {
  const [tabIndex, setTabIndex] = useState(0);

  const paperRefs = useRef<HTMLElement>();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
    const currentElement = paperRefs.current?.children[newValue];
    if (currentElement) {
      currentElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };
  const updateTab = (index: number) => setTabIndex(index);

  return (
    <Grid container width={'100%'} rowSpacing={2}>
      <Grid item xs={3}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={tabIndex}
          onChange={handleTabChange}
        >
          <ProfileTab label={'Personal and Contact Information'} />
          <ProfileTab label={'Job Preference And Availability'} />
          <ProfileTab label={'Compensation and Benefits'} />
          <ProfileTab label={'Skills'} />
          <ProfileTab label={'Other Information'} />
          <ProfileTab label={'Experience'} />
          <ProfileTab label={'Education'} />
          <ProfileTab label={'Certification'} />
        </Tabs>
      </Grid>

      <Grid
        item
        xs={9}
        overflow="auto"
        maxHeight="90vh"
        p={3}
        mt={2}
        sx={{ background: WsColors.TertiaryShades50 }}
      >
        <UpdateCandidateDetailsCard
          title={'Personal and Contact Information'}
          onChange={updateTab}
          description={'Manage personal details, contant info and visa details.'}
          paperRefs={paperRefs}
          close={close}
          candidate={candidate}
          updateCandidate={updateCandidate}
        />
      </Grid>
    </Grid>
  );
};

export default CandidateProfileDetailsEdit;
